import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment'
import _ from 'lodash'
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import TableFooter from '@material-ui/core/TableFooter';
import { green, red } from '@material-ui/core/colors'; 
import RemoveCircle from '@material-ui/icons/RemoveCircle';
import AddCircleOutline from '@material-ui/icons/AddCircleOutline';
import PropTypes from 'prop-types';
import {observable} from 'mobx'
import { inject, observer } from 'mobx-react';
import {pending} from '../stores/State'
import PALLET_SIZE from '../models/PalletSize'
import TRANSACTION_TYPE from '../models/TransactionType'
import InventoryTransactionsMap from './InventoryTransactionsMap'
import TransactionsTable from './TransactionsTable';
import {withRouter} from "react-router-dom";

@inject('store')
@observer
class TokenTransactions extends Component {
  @observable rowsPerPage = 10
  @observable page = 0

  componentWillReceiveProps(nextProps){
    if(!_.isEqual(this.props, nextProps)) this.fetchTransactions(nextProps.token, nextProps.campaignPrefix);
  }

  componentDidMount(){
    this.fetchTransactions();
  }

  handlePageChange(page){
    this.page = page;
    this.fetchTransactions();
  }

  handleRowsPerPageChange(rowsPerPage){
    this.rowsPerPage = rowsPerPage;
    this.fetchTransactions()
  }

  fetchTransactions(token, campaignPrefix){
    const store = this.props.store.transactionStore;
    store.fetchTokenTransactions(token || this.props.token, campaignPrefix || this.props.campaignPrefix, this.rowsPerPage, this.page);
  }

  render() {
    const { classes } = this.props;
    const store = this.props.store.transactionStore;
    
    return (
      <div>
        <Paper className={classes.paper}>
          <Typography variant='subheading'>Transactions</Typography>
          { store.transactionsState === pending && <CircularProgress /> }
          { store.transactions && 
              <TransactionsTable
              transactions={store.transactions.results}
              count={store.transactions.count}
              rowsPerPage={this.rowsPerPage}
              page={this.page}
              onChangePage={(event, page)=>this.handlePageChange(page)}
              onChangeRowsPerPage={(event)=>this.handleRowsPerPageChange(event.target.value)}
            /> }
          </Paper>
          <InventoryTransactionsMap/>
        </div>
    );
  }
}

const styles = theme => ({
  paper: {
    padding: 20,
    marginBottom: 20
  },
  addIcon:{
    color: green[500]
  },
  removeIcon:{
    color: red[500]
  }
});

TokenTransactions.propTypes = {
  token: PropTypes.string,
  campaignPrefix: PropTypes.string
}

export default withRouter(withStyles(styles)(TokenTransactions));



// WEBPACK FOOTER //
// ./src/components/TokenTransactions.js